<script>
    import BackgroundMediaMixin from '../../../author/pagesbuilder/mixins/BackgroundMediaMixin.vue'
    import ScreenCaptionMixin from "../../../author/pagesbuilder/mixins/ScreenCaptionMixin";
    
    export default {
        name: "ScreenElement",
        mixins: [
            BackgroundMediaMixin,
            ScreenCaptionMixin,
        ],
        data () {
            return {
                elementType: 'screen',
                givesContextToChildren: true,
                defaultImageClass : "learnworlds-bg-default"
            }
        },
        computed: {
            nodeWithBgImage () {
                let nodeWithImage = this.myNode.querySelector("." + this.classSelectors.imageNode);
                return nodeWithImage ? nodeWithImage : this.myNode;
            },
            nodeWithColor () {
                return this.nodeWithBgImage;
            },
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    selectedMedia : this.getScreenMediaOnInit(),
                    hideVideoBelow : "None",
                    imageMediaData : null,
                    videoMediaData: null,
                    embedMediaData: null,
                    responsiveScreenCaptionPositionClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    itemVisibilitySettings: null
                };

            },
        },
        methods: {
            getScreenMediaOnInit () {
                if (this.registrationData.screenSelectedMedia) {
                    return this.registrationData.screenSelectedMedia;
                } else if (
                    this.hasContext('column-wrapper') &&
                    this.findNodeState(this.hasContext('column-wrapper')[0]['id']) &&
                    this.findNodeState(this.hasContext('column-wrapper')[0]['id']).registrationData &&
                    this.findNodeState(this.hasContext('column-wrapper')[0]['id']).registrationData.screenSelectedMedia
                ) {
                    return this.findNodeState(this.hasContext('column-wrapper')[0]['id']).registrationData.screenSelectedMedia;
                } else if (this.nodeWithBgImage && this.nodeWithBgImage.classList.contains(this.defaultImageClass)) {
                    return "Image";
                }

                return "";

            },
            elementCreationCallback () {
                if (this.myData && this.myData.selectedMedia === "Video") {
                    this.renderVideo();
                }
            },
            toggleBgImageDisplay (flag) {
                if (flag) {
                    this.nodeWithBgImage.style.display =  null;
                    this.insertBgImage();
                } else {

                    if (this.getSelectedMedia && this.getSelectedMedia !== "Color") {
                        this.nodeWithBgImage.style.display =  "none";
                    }

                    this.removeBgImage();
                }
            },
            addVideoListeners() {
                this.toggleInteractionWithFrame(false);
            },
            showImage () {
                this.toggleEmbedWrapperDisplay(false);
                this.toggleVideoWrapperDisplay(false);
                this.toggleBgImageDisplay(true);
            },
            showColor () {
                this.toggleEmbedWrapperDisplay(false);
                this.toggleVideoWrapperDisplay(false);
                this.toggleColorOnlyDisplay(true);
            },
            showVideo () {
                this.toggleEmbedWrapperDisplay(false);
                this.toggleVideoWrapperDisplay(true);
                this.toggleBgImageDisplay(false);
            }
        },
    }
</script>

<style>
    .hide-video > iframe {
        display: none;
    }
    .hide-video-icon > span {
        display: none;
    }
</style>